<template>
  <v-container class="d-flex flex-column" style="height:100%!important;">
    <div class="d-flex flex-row align-center justify-start ma-4">
      <v-btn rounded depressed @click="closeModal" class="text-none font-weight-medium">
        <v-icon class="mr-1">mdi-undo-variant</v-icon> {{  $t('global.cancel')  }}
      </v-btn>
      <span class="title ml-4 text-left text-uppercase" style="color:var(--v-primary-base);">Diffuser maintenant</span>
    </div>
    <v-skeleton-loader :transition="transition" type="image" class="mx-auto" height="288px" width="512px" v-if="!doneFetching">
    </v-skeleton-loader>
     <v-skeleton-loader :transition="transition" type="article" class="mx-auto" height="200px" width="512px" v-if="!doneFetching">
    </v-skeleton-loader>
    <div v-if="doneFetching" class="d-flex flex-column" height="100%">
      <div class="preview-card ongoing flex-grow-0">
        <div class="impage_bloc_large mx-auto">
          <v-img class="photo_large" v-if="media && doneFetching" :src="thumbnailPath" width="100%" height="100%"></v-img>
          <div class="status">
            <v-btn loading text icon depressed color="white" style="position:absolute;left:10px;bottom:7px;color:white;height:24px;width:24px;"></v-btn>
            <div class="status_title"> En attente de votre confirmation </div>
            <div style="position:absolute;right:0px;bottom:0px;height:30px;width:34px;background-color:#252735;border-radius:6px 0px 0px 0px;">
              <v-icon style="position:absolute;right:5px;bottom:3px;color:white;">mdi-image-size-select-actual</v-icon>
            </div>
          </div>
        </div>
        <div class="photo_name mx-6 my-4">
          {{ media.titre }}
        </div>
      </div>
      <div class="mx-6 pb-4">
        <h4 class="mb-3">
          {{ text }}
        </h4>
        <div>
          <template v-if="screens.length > 1">
            <v-list id="screenslist" style="overflow-y:auto;max-height:200px;">
              <v-list-item v-for="screen in screens" :key="screen">
                <v-list-item-action >
                  <v-checkbox off-icon="mdi-television-pause" on-icon="mdi-television-play" color="rgb(var(--startBroadcast-rgb))" :label="screen" v-model="selectedScreens" :value="screen"></v-checkbox>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </template>
          <template v-if="screens.length === 1">
            <v-icon class="mr-1 pl-4" color="rgb(var(--startBroadcast-rgb))">mdi-television-play</v-icon>
            <span> {{ screens[0] }} </span>
          </template>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="ma-6 flex-grow-0">
        <v-btn rounded outlined large block class="custom-valid-btn start-broadcast" @click="startContent" :disabled="screens.length > 1 && selectedScreens.length === 0 ">
          Démarrer la diffusion
        </v-btn>
      </div>
    </div>
    <v-snackbar @click.native="snackbarStartSuccessful = true" v-model="snackbarStartSuccessful" :timeout="timeoutDuration">
      Le média a été mis en diffusion
    </v-snackbar>
    <v-snackbar @click.native="snackbackStartFailed = false" v-model="snackbackStartFailed" :timeout="timeoutDuration">
      Le média n'a pas pu être mis en diffusion
    </v-snackbar>
  </v-container>
</template>

<script>
import FtpService from '@/services/FTPService'

export default {
  props: ['file'],
  data () {
    return {
      media: null,
      screens: [],
      title: '',
      text: '',
      selectedScreens: [],
      doneFetching: false,
      transition: 'scale-transition',
      site: '',
      timeoutDuration: 4000,
      snackbarStartSuccessful: false,
      snackbackStartFailed: false,
      thumbnailPath: ''

    }
  },
  async created () {
    const serverPath = 'https://sandisplay.allsan.fr/players/' + this.$store.state.selectedSite.SitNom + '/PUB/'
    this.media = this.file
    
    this.site = this.$store.state.selectedSite.SitNom
    if (this.$store.state.selectedScreen !== null) {
      this.selectedScreens = [this.$store.state.selectedScreen.server_name]
      if (this.media.ecrans.includes(',')) {
        this.screens = this.media.ecrans.split(',')
      } else {
        this.screens = [this.media.ecrans]
      }
    } else {
      if (this.media.ecrans.includes(',')) {
        this.screens = this.media.ecrans.split(',')
      } else {
        this.screens = [this.media.ecrans]
      }
     
    }
    if (this.screens.length === 1) {
      this.selectedScreens = this.screens
    }
    if (this.media.miniature){
      this.thumbnailPath = serverPath + this.screens[0] + '/' + this.media.miniature
      this.doneFetching = true
    } else {
      this.thumbnailPath = serverPath + this.screens[0] + '/bloc_pub1/' + this.media.media_name
      this.doneFetching = true
    }
  },
  methods: {
    closeModal () {
      document.location.reload(true)
    },
    async startContent () {
      const response = await FtpService.startBroadcast({
        site: this.site,
        filename: this.media.media_name
      })
      if (response.status === 200) {
        this.snackbarStartSuccessful = true
        this.closeModal()
      } else {
        this.snackbackStartFailed = true
      }
    }
  },
  watch: {
    screens: function () {
      this.title = this.screens.length > 1 ? 'Écrans de diffusion' : 'Écran de diffusion'
      this.text = this.screens.length > 1
        ? 'Ce média a été programmé sur les écrans suivants. Cochez les écrans qui le diffuseront dès maintenant.'
        : 'Ce média sera diffusé sur l\'écran suivant :'
    }
  }
}
</script>

<style scoped>

</style>
